import React from "react"
import _ from "lodash"

import DateField from "components/table/display/date"

const UnitEndDisplay = (props: {rowData: {}, field: string}) => {
  const unitEnd = _.get(props.rowData, props.field)

  let display
  if(!unitEnd) {
    display = "None"
  } else if(unitEnd.state === "analysisEnd") {
    display = "Analysis End"
  } else if(unitEnd.state === "none") {
    display = "None"
  } else if(unitEnd.state === "specifiedDate") {
    display = <DateField rowData={unitEnd} field="date" allowRelative withoutDays/>
  } else {
    display = "None"
  }

  return (
    <span>{display}</span>
  )
}

export default UnitEndDisplay
